import GeneralDialog from "../../core/GeneralDialog";

const InvoiceRevertDialog = (props: InvoiceRevertDialogProps) => {
  return props.open ? (
    <GeneralDialog
      open={props.open}
      title={props.isEditMode ? "請求確定取り消し" : "確定取り消し"}
      cancelText="キャンセル"
      saveText="確定を取り消す"
      onCancel={() => props.onClose()}
      onSave={() => props.onOk()}
      onClose={() => props.onClose()}
    >
      <div>既に確定済の請求です。</div>
      {props.isEditMode ? <div>内容を編集するには請求の確定取り消しが必要です。<br/></div> : <></>}
      <div>編集の確定を取り消しますか？</div>
    </GeneralDialog>
  ) : (
    <></>
  );
};

export default InvoiceRevertDialog;

export type InvoiceRevertDialogProps = {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  isEditMode: boolean;
};
